<template>
  <b-container class="uk-flex-column uk-position-center bsb-text main-container">
    <slot></slot>
  </b-container>
</template>

<script>
export default {
  name: 'CommonPagesMainContainer'
}
</script>

<style scoped>
.main-container {
  margin: 0 !important;
  padding: 0 !important;
  width: 738px;
  max-width: 95vw;
}
</style>
